import { Route } from '../ARoute'

function userLazyload(view) {
  return () =>
    import(/* webpackChunkName: "view-system-" */ `@src/views/overview/${view}`)
}

export default Route.withPageLayout('tong-quan').addChildren([
  Route.redirect('', { name: 'logs' }).withName('hethong'),
  Route.withPath('file-log-loi', userLazyload('log-errors/log-errors-main.vue'))
    .withName('log-errors')
    .withTitleText('File log lỗi')
    .requireHasAnyInScopes(['log-file-errors-management']),
  Route.withPath('chi-tiet', 'overview/summary')
    .withName('system-summary')
    .withTitleText('Tổng quan hệ thống')
    .requireHasAnyInScopes(['system-summary']),
  Route.withPath('nhat-ky', 'log/LogMain')
    .requireHasAnyInScopes(['log-management'])
    .withName('logs')
    .withTitle('sidebar.logs.name'),
])
